import instance from "./instanceNoAuth";
import instanceAuth from "./instance";
import { API_URL } from "../config/api";

export default class AuthService {
  static login = async (username, password) => {
      const res = await instance.post(API_URL.LOGIN, {username, password});
      // console.log(res.data.data.result);
      if (res && res.status && res.status === 200) {
        return {success: true, data: res.data.data.result ,msg: ["success"]}
      }
      else if(res && res.data && res.data.err) {
        return {success: false, msg: [res.data.err]}
      }
      else {
        console.error(res);
        return {success: false, msg: ["Something went wrong!"]}
      }
  }
  static tokenRefresh = async () => {
    try {
        const refreshToken = localStorage.getItem("refreshToken");
        await instanceAuth.post(API_URL.REFRESH, {refresh_token: refreshToken});
    } catch (e) {
        console.error(e)
    }

  }
  static user = async () => {
      try{
          const refreshToken = localStorage.getItem("refreshToken");
          const res = await instanceAuth.post(API_URL.REFRESH, {refresh_token: refreshToken});
          return res.data.data.result

      } catch (e) {
          console.error(e);
      }
  }
}